<template>
    <div id="frequency-watch-hh">
        <section class="frequency-layout">
            <header class="frequency-filters">
                <div class="filter">
                    <label class="inputLabel" for="date"> Select From and To Date </label>
                    <DateRangePicker :options="{ startDate: dateFrom, endDate: dateTo }">
                        <input
                            ref="dateInput"
                            type="text"
                            class="form-control"
                            name="daterange"
                            placeholder="MM/DD/YYYY"
                            :value="newDateRange"
                            @change="(event) => setnewTaskDateRange(event.target.value)"
                        />
                    </DateRangePicker>
                </div>
                <div class="filter">
                    <label class="inputLabel" for="agency-id"> Organization </label>
                    <select
                        class="form-control pl-1"
                        name="agencies"
                        v-model="selectedAgency"
                        @change="updateBranchesbyAgency"
                    >
                        <option v-for="(value, key) of agencyOptions" :value="value.value" :key="key">
                            {{ value.name }}
                        </option>
                    </select>
                    <!-- Uncomment this once BE accept multiple agencies -->
                    <!-- <MultiSelect
                        :dropDownOptions="agencyMultiSelectOptions"
                        labelText="Agencies"
                        :selectedOptions="selectedAgencies"
                        v-on:updateBranches="updateBranchesbyAgency"
                    /> -->
                </div>
                <div class="filter">
                    <label class="inputLabel" for="agency-location-id"> Branch </label>
                    <MultiSelect
                        :dropDownOptions="branchMultiSelectOptions"
                        labelText="Branches"
                        :selectedOptions="selectedBranches"
                        v-on:updateBranches="updateBranches"
                    />
                </div>
                <!-- we can uncomment this once BE is accepting this filter -->
                <!-- <div class="filter">
                    <label class="inputLabel" for="frequency-variance">Frequency Variance</label>
                    <select class="form-control pl-1" name="weekday-range" v-model="frequencyVariance">
                        <option
                            v-for="[key, value] in enumToMap(FrequencyVarianceEnums)"
                            :value="value.value"
                            :key="key"
                        >
                            {{ value.name }}
                        </option>
                    </select>
                </div> -->
                <div class="filter">
                    <label class="inputLabel" for="client-list"> Frequency Status </label>
                    <MultiSelectFilter
                        ref="statusFilter"
                        id="status-list"
                        :on-fetch="frequencyStatusesFetch"
                        v-model:selected-items="selectedStatuses"
                        v-on:selectedItemsUpdated="selectedStatusesUpdated"
                        name="Statuses"
                    />
                </div>
                <!-- we can uncomment this once BE is accepting this filter -->
                <!-- <div class="filter">
                    <label class="inputLabel" for="client-list"> Frequency Discipline </label>
                    <MultiSelectFilter
                        ref="statusFilter"
                        id="status-list"
                        :on-fetch="frequencyDisciplineFetch"
                        v-model:selected-items="selectedDiscipline"
                        v-on:selectedItemsUpdated="selectedItemsUpdated"
                        name="Discipline"
                    />
                </div> -->
                <div class="mt-4 pt-1">
                    <button type="button" class="btn btn-primary me-2" @click="generate()">Generate</button>
                    <button type="button" class="btn btn-outline-primary" @click="clearFilters()">Clear</button>
                </div>
            </header>
            <main class="bg-white rounded mt-2 h-100">
                <PageLayout>
                    <template #content>
                        <div class="h-100 d-flex flex-column mb-3 mt-2">
                            <div class="table-scroll-wrapper">
                                <Pagination
                                    ref="freqyencyWatchHHPagination"
                                    :pageChanged="pageChangedCallback"
                                    :isLoading="isLoading"
                                    entity="Frequency Watch"
                                    :showPageSizeOptions="true"
                                    classes="pagination-footer pb-2"
                                    :pageSize="pageSize"
                                    v-on:updatePageSizeChanged="updatePageSizeChanged"
                                >
                                    <table class="table table-responsive-md border border-gray">
                                        <thead>
                                            <tr class="bg-table-header">
                                                <!-- <th></th> -->
                                                <th>
                                                    <SortableTh
                                                        :sort-by="sortBy"
                                                        v-on:sortByUpdated="sortByUpdated"
                                                        :sort-order="sortOrder"
                                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                                        sort-string="patientName"
                                                        class="justify-content-start"
                                                    >
                                                        Patient Name
                                                    </SortableTh>
                                                </th>
                                                <th>
                                                    <SortableTh
                                                        :sort-by="sortBy"
                                                        v-on:sortByUpdated="sortByUpdated"
                                                        :sort-order="sortOrder"
                                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                                        sort-string="branchName"
                                                        class="justify-content-start"
                                                    >
                                                        Branch
                                                    </SortableTh>
                                                </th>
                                                <th>Discipline</th>
                                                <th>Frequency</th>
                                                <th>
                                                    <SortableTh
                                                        :sort-by="sortBy"
                                                        v-on:sortByUpdated="sortByUpdated"
                                                        :sort-order="sortOrder"
                                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                                        sort-string="frequencyStatus"
                                                        class="justify-content-start"
                                                    >
                                                        Frequency Status
                                                    </SortableTh>
                                                </th>
                                                <th>
                                                    <SortableTh
                                                        :sort-by="sortBy"
                                                        v-on:sortByUpdated="sortByUpdated"
                                                        :sort-order="sortOrder"
                                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                                        sort-string="startDate"
                                                        class="justify-content-start"
                                                    >
                                                        Start Date
                                                    </SortableTh>
                                                </th>
                                                <th>
                                                    <SortableTh
                                                        :sort-by="sortBy"
                                                        v-on:sortByUpdated="sortByUpdated"
                                                        :sort-order="sortOrder"
                                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                                        sort-string="endDate"
                                                        class="justify-content-start"
                                                    >
                                                        End Date
                                                    </SortableTh>
                                                </th>
                                                <th>
                                                    <SortableTh
                                                        :sort-by="sortBy"
                                                        v-on:sortByUpdated="sortByUpdated"
                                                        :sort-order="sortOrder"
                                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                                        sort-string="visitsScheduled"
                                                        class="justify-content-start"
                                                    >
                                                        Visits Scheduled
                                                    </SortableTh>
                                                </th>
                                                <th>
                                                    <SortableTh
                                                        :sort-by="sortBy"
                                                        v-on:sortByUpdated="sortByUpdated"
                                                        :sort-order="sortOrder"
                                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                                        sort-string="visitsOrdered"
                                                        class="justify-content-start"
                                                    >
                                                        Visits Ordered
                                                    </SortableTh>
                                                </th>
                                                <th>Scheduled Variance</th>

                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <!-- EMPTY -->
                                            <tr class="table-empty" v-if="!isLoading && !isError && !hasData">
                                                <td :colspan="columns">
                                                    <h3>No Tasks Found.</h3>
                                                </td>
                                            </tr>
                                            <!-- ERROR -->
                                            <tr class="table-error" v-if="!isLoading && isError">
                                                <td :colspan="columns">
                                                    <ErrorMessageHandler
                                                        title="Frequency Watch list"
                                                        v-on:try-again="pageReset()"
                                                    />
                                                </td>
                                            </tr>
                                            <!-- LOADING -->
                                            <template v-if="isLoading">
                                                <tr v-for="i of loadingCount" class="table-loading" :key="i">
                                                    <td v-for="i of columns" :key="i">
                                                        <span class="shimmer-loading"></span>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                        <!-- LIST -->
                                        <template v-if="!isLoading && !isError && hasData">
                                            <tbody v-for="item in page.Items" :key="item.PatientId">
                                                <FrequencyWatchHHRow
                                                    :frequencyItem="item"
                                                    :columns="columns"
                                                    :application="application"
                                                    :selectedAgency="selectedAgency"
                                                    :selectedBranches="selectedBranches[0]"
                                                />
                                            </tbody>
                                        </template>
                                    </table>
                                </Pagination>
                            </div>
                        </div>
                    </template>
                </PageLayout>
            </main>
        </section>
    </div>
</template>

<style src="./FrequencyWatchHH.scss"></style>
<script src="./FrequencyWatchHH.ts"></script>
